<!--
 * @LastEditors: chg
 * @desc: 登录页面
-->
<template>
  <div>
    <div id="login-box" class="panel2"   :class="[{ 'panel2--m': isMobile }]">
      <div v-if="this.windowData && accessLogin" style="height: 160px; line-height: 160px;">
        <span>验证登录中，请稍后...</span>
      </div>
      <div v-else-if="showLogin && !accessLogin">
        <p><span style="color:indianred;">观照</span>：交互式投资决策分析平台</p>
        <img :src="introImgUrl" style="width:200px">
        <form>
          <div style="margin-top: 10px;">
            <el-input v-model="phone" type="text" placeholder="请输入手机号">
              <template slot="prepend">手机号</template>
            </el-input>
          </div>
          <div style="margin-top: 10px;">
            <el-input @keyup.enter="login" v-model="password" type="password" placeholder="请输入密码">
              <template slot="prepend">密&emsp;码</template>
            </el-input>
          </div>
        </form>
        <el-row style="margin-top: 10px;">
          <el-col :span="24">
            <el-button v-on:click="login" style="width:100%" type="primary">登录</el-button>
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="24">
            <el-button class="el-input-noboarder" v-on:click="showLogin=!showLogin">还没有账号？去注册</el-button>
          </el-col>
        </el-row>
      </div>
      <div id="register-box" v-else-if="!showLogin">
        <p><span style="color:indianred;">观照</span>：交互式投资决策分析平台</p>
        <img :src="introImgUrl" style="width:200px">
        <el-row style="margin-top: 10px;">
          <el-col :span="24">
            <el-input v-model="phone" placeholder="请输入手机号">
              <template slot="prepend">手机号</template>
            </el-input>
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="24">
            <el-input v-model="userName" placeholder="请输入用户名">
              <template slot="prepend">用户名</template>
            </el-input>
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="24">
            <el-input v-model="realName" placeholder="请输入真实姓名">
              <template slot="prepend">真实姓名</template>
            </el-input>
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="24">
            <el-input v-model="organization" placeholder="请输入任职机构">
              <template slot="prepend">所在机构名称</template>
            </el-input>
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="24">
            <form>
              <el-input  v-model="password" type="password" placeholder="请输入密码">
                <template slot="prepend">密&emsp;码</template>
              </el-input>
            </form>
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="24">
            <el-input  @keyup.enter="check" v-model="invitation" placeholder="请输入邀请码">
              <template slot="prepend">邀请码</template>
            </el-input>
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="24">
            <el-button id="login" v-on:click="check" style="width:100%" type="primary">注册</el-button>
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="24">
            <el-button class="el-input-noboarder" v-on:click="showLogin=!showLogin">已有账号，让我登录</el-button>
          </el-col>
        </el-row>
      </div>
    </div>
    <webFooter style="margin-top: 10px;"></webFooter>
  </div>
</template>
<script>
import CryptoJS from 'crypto-js'
import webFooter from '@/components/webFooter.vue'
import { postRegister, postLogin, postDunheLogin } from '@/api/login.js'
import { mapMutations, mapGetters } from 'vuex'
import { Loading } from 'element-ui'
import { postRequest } from '@/api/dailyBackTest'
export default{
  name: 'LyLogin',

  components: {
    webFooter
  },
  data () {
    return {
      introImgUrl: require('@/assets/welcome.jpg'),
      // email: '',
      phone: '',
      userName: '',
      password: '',
      showLogin: true,
      invitation: '',
      realName: '',
      organization: '',
      windowData: {},
      accessLogin: false,
      userToken: '',
      time: ''
    }
  },

  computed: {
    ...mapGetters(['isMobile'])
  },

  mounted () {
    this.getDate()
    localStorage.removeItem('Authorization')
    sessionStorage.userName = ''
    localStorage.userName = ''
    this.loadingInstance = Loading.service({ fullscreen: true })
    this.loadingInstance.close()

    // 获取vue-router传过来的参数
    const query = this.$route.query
    if (query && query.access_token != null) {
      this.windowData['access_token'] = query.access_token
      this.accessTokenLogin(query.access_token)
      return
    }
    var test1 = window.location.href
    let index1 = test1.indexOf('token')
    if (index1 > -1) {
      test1 = test1.substring(index1)
      let access = test1.split('&')
      for (let i = 0; i < access.length; i++) {
        let accessData = access[i].split('=')
        this.windowData[accessData[0]] = accessData[1].split('%20').join(' ')
        this.accessLogin = true
        if (this.windowData['token']) {
          this.changeLogin({ Authorization: this.windowData['token'] })
        }
      }
      setTimeout(() => {
        this.tokenLogin()
      }, 500)
    }
  },
  methods: {
    ...mapMutations(['changeLogin']),
    check: function (event) {
      var rs = /^1[3-9]\d{9}$/
      if (!rs.test(this.phone)) {
        this.$message({
          message: '请输入正确的手机号',
          type: 'error'
        })
        return
      }
      if (this.phone === '' || this.userName === '' || this.password === '') {
        this.$message({
          message: '账号或密码为空！',
          type: 'error'
        })
        return
      }
      if (this.realName === '') {
        this.$message({
          message: '请输入真实姓名！',
          type: 'error'
        })
        return
      }
      if (this.organization === '') {
        this.$message({
          message: '请输入所在机构名称！',
          type: 'error'
        })
        return
      }
      if (this.invitation !== 'dunhe') {
        this.$message({
          message: '封闭测试期，请输入邀请码:-)',
          type: 'warning'
        })
        return
      }
      var _this = this
      postRegister({userName: this.userName, phone: this.phone, password: CryptoJS.MD5(this.phone + CryptoJS.MD5(this.password)).toString(), realName: this.realName, organization: this.organization, examine: false}).then(function (data) {
        _this.$message({
          message: data.data.text,
          type: data.data.type
        })
        if (data.data.type === 'success') {
          _this.showLogin = !_this.showLogin
        }
      })
    },
    getDate () {
      const myDate = new Date()
      const year = myDate.getFullYear()
      const month = myDate.getMonth() + 1
      const date = myDate.getDate()
      this.time =
        year.toString() +
        this.convert(month).toString() +
        this.convert(date).toString()
    },
    convert (val) {
      return val < 10 ? '0' + val : val
    },
    login () {
      // var email = this.email
      var phone = this.phone
      var password = this.password
      var rs = /^1[3-9]\d{9}$/
      if (!rs.test(this.phone)) {
        this.$message({
          message: '请输入正确的手机号',
          type: 'error'
        })
        return
      }
      if (phone === '' || password === '') {
        this.$message({
          message: '账号或密码为空！',
          type: 'error'
        })
        return
      }
      var _this = this
      postLogin({phone: this.phone, password: CryptoJS.MD5(this.phone + CryptoJS.MD5(this.password)).toString()}).then(function (data) {
        if (data.data.code === 1001) {
          _this.$message({
            message: data.data.message
          })
        }
        if (data.data.code === 0) {
          if (data.data.data.examine === false) {
            _this.$message({
              message: '您的申请还在审核中，请稍后再来'
            })
            return
          }
          sessionStorage.userName = data.data.data.userName
          localStorage.userName = data.data.data.userName
          sessionStorage.is_admin = data.data.data.is_admin
          localStorage.is_admin = data.data.data.is_admin
          sessionStorage.is_super_admin = data.data.data.is_super_admin
          localStorage.is_super_admin = data.data.data.is_super_admin
          sessionStorage.organization = data.data.data.organization
          localStorage.organization = data.data.data.organization
          _this.userToken = 'Bearer ' + data.data.data.token
          // 将用户token保存到vuex中
          _this.changeLogin({ Authorization: _this.userToken, loginDate: _this.time, userName: data.data.data.userName })
          _this.$emit('loginDone')
        }
      })
    },
    accessTokenLogin (accessToken) {
      var _this = this
      postDunheLogin({access_token: accessToken}).then(function (data) {
        _this.accessLogin = false
        if (data.data.code !== 0) {
          _this.$message({
            message: data.data.message
          })
        } else if (data.data.code === 0) {
          sessionStorage.userName = data.data.data.userName
          localStorage.userName = data.data.data.userName
          sessionStorage.is_admin = data.data.data.is_admin
          localStorage.is_admin = data.data.data.is_admin
          sessionStorage.is_super_admin = data.data.data.is_super_admin
          localStorage.is_super_admin = data.data.data.is_super_admin
          sessionStorage.organization = data.data.data.organization
          localStorage.organization = data.data.data.organization
          _this.userToken = 'Bearer ' + data.data.data.token
          // 将用户token保存到vuex中
          _this.changeLogin({ Authorization: _this.userToken, loginDate: _this.time, userName: data.data.data.userName })
          _this.$emit('loginDone')
        }
      })
    },
    tokenLogin () {
      // console.log('tokenLogin')
      var _this = this
      postRequest('/user/refresh_token').then(function (data) {
        _this.accessLogin = false
        if (data.data.code !== 0) {
          _this.$message({
            message: data.data.message
          })
        } else if (data.data.code === 0) {
          sessionStorage.userName = data.data.data.userName
          localStorage.userName = data.data.data.userName
          sessionStorage.is_admin = data.data.data.is_admin
          localStorage.is_admin = data.data.data.is_admin
          sessionStorage.is_super_admin = data.data.data.is_super_admin
          localStorage.is_super_admin = data.data.data.is_super_admin
          sessionStorage.organization = data.data.data.organization
          localStorage.organization = data.data.data.organization
          _this.userToken = 'Bearer ' + data.data.data.token
          // 将用户token保存到vuex中
          _this.changeLogin({ Authorization: _this.userToken, loginDate: _this.time, userName: data.data.data.userName })
          _this.$emit('loginDone')
        }
      })
    }
  }
}
</script>
<style>
  .el-row {
    margin-bottom: 20px;
  }
  #login-box {
    margin: 0px auto;
    min-width: 400px;
    max-width: 600px;
  }
  el-input {
    margin-left:10%;
  }
  .el-input-noboarder {
    border-top-width: 0px;
    border-left-width: 0px;
    border-right-width: 0px;
    border-bottom-width: 1px;
    padding-top:10px;
    padding-bottom:0px;
    font-family: "WenQuanYi Micro Hei";
  }
  .panel2 {
    border: 1px solid #d1dbe5;
    /* margin: 20% 20px 0; */
    padding:30px;
    box-shadow: 0 1px 3px rgba(27,95,160,.1);
    background: #fff
  }
  .panel2--m{
    min-width: auto !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue